import './styles/fonts.css';
import './styles/theme.css';
import './styles/base.css';
import './styles/layout.css';
import './styles/components.css';
import './styles/effects.css';

import { App } from './app.js';
import { setLocale } from './i18n/index.js';

setLocale('en');

const root = document.querySelector<HTMLDivElement>('#app');
if (root) void new App(root).start();
